import {
  baseApi,
  type OmegaApiResponse,
} from '@shared/api';
import {
  mapReferral,
  mapReferAFriendPageState,
  type Referral
} from '../lib';


export type GetRefereesResponse = OmegaApiResponse & {
  referrerUserId: Email;
  referrerPartyId: number;
  referrerBrand: 'SweepLuxe';
  referees: Array<Referral>;
};

export const referralPageSlice = baseApi.injectEndpoints({
  endpoints: build => ({
    // TODO: fix any type
    getReferAFriendPage: build.query<any, void>({
      query: () => ({ url: '/api/refer-a-friend-page' }),
      extraOptions: { showLoader: false, auth: false },
      transformResponse: (response: { data: unknown }) =>
        mapReferAFriendPageState(response.data),
    }),
    getReferees: build.query<GetRefereesResponse, void>({
      query: () => ({ url: '/api/ips/get-referees' }),
      extraOptions: { showLoader: false, auth: true },
      transformResponse: (response: { referees: Array<unknown> }) => {
        const mappedReferees = response.referees.map(mapReferral);
        return { ...response, referees: mappedReferees } as unknown as GetRefereesResponse;
      }
    }),
  }),
});

export const {
  useGetRefereesQuery,
  useLazyGetRefereesQuery,
  useGetReferAFriendPageQuery,
  useLazyGetReferAFriendPageQuery,
} = referralPageSlice;
